<template>
  <div>
    <button hidden :id="`offcanvas_button`" type="button" data-bs-toggle="offcanvas" :data-bs-target="`#offcanvas`"
      aria-controls="staticBackdrop"></button>
    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvas" aria-labelledby="staticBackdropLabel"
      data-bs-backdrop="static">
      <div class="offcanvas-header">
        <div class="d-flex flex-fill justify-content-between align-items-center">
          <div class="">
            <i class="fa-solid fa-arrow-left fs-2 text-dark cursor-pointer" style="left: 20px"
              @click="canvasBackPressed" />
          </div>
          <div class="">
            <p class="text-dark m-0 fw-bold" id="staticBackdropLabel">
              {{ title }}
            </p>
          </div>
          <div class="">
            <i class="fa-solid fa-times text-muted fs-2 cursor-pointer" style="left: 20px" @click="closeCanvas" />
          </div>
        </div>
      </div>
      <div class="overflow-scroll">
        <div class="">
          <component :is="View" v-bind="viewProps" />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { EOffcanvasPage, OffCanvasPages } from './canvas.pages';

import useOffCanvas from './useOffCanvas';
const { topItemInStack, canvasBackPressed, closeCanvas } = useOffCanvas()
const title = computed(() => topItemInStack.value?.title || '');
const View = computed(() => {
  if (topItemInStack.value) {
    return OffCanvasPages[topItemInStack.value.key as EOffcanvasPage].component
  }
  return null
});
const viewProps = computed(() => {
  return topItemInStack.value?.props || null;
});

</script>
<style>
.offcanvas-header {
  padding: 1rem !important
}
</style>